<template>
  <div class="grid-slider" :class="{'grid-layout': hasFirstSlideSlot}">
    <UiText
      v-if="headerText"
      class="grid-slider__text"
      font="components-section-title"
      color="typography-title01"
      :text="headerText"
    />

    <slot name="headline">
      <HeadlineAction
        v-if="title"
        :title="title"
        :img="img"
        class="grid-slider__header"
      />
    </slot>

    <slot name="first-slide" :slide="list[0]" :class-name="'grid-slider__grid-item'" />

    <div
      ref="slider"
      v-swiper:swiper="c_options"
      class="grid-slider__container swiper"
    >
      <div class="grid-slider__actions">
        <div v-if="!isHideNavigation" class="grid-slider__nav">
          <UiBtn
            icon-only
            color="line"
            class="prev"
            icon="chevrons/chevron-left"
          />
          <div class="grid-slider__pagination swiper-pagination" />
          <UiBtn
            icon-only
            color="line"
            class="next"
            icon="chevrons/chevron-right"
          />
        </div>
        <div v-if="linkBtn" class="grid-slider__btn">
          <span v-if="!isHideNavigation" class="grid-slider__btn-divider" />
          <UiBtn
            :to="linkBtn"
            text="До розділу"
            color="transparent"
          />
        </div>
        <UiBtn
          v-if="linkBtn"
          class="grid-slider__action-btn"
          size="s"
          :to="linkBtn"
          text="До розділу"
          color="transparent"
        />
      </div>

      <div class="grid-slider__wrapper swiper-wrapper">
        <template v-for="(item, index) in c_list">
          <div
            ref="slide"
            :key="index"
            class="grid-slider__item swiper-slide"
          >
            <template v-if="row > 1">
              <div
                v-for="(inner, i) in item"
                :key="(!inner && i) || inner[keyItem] || inner.uuid || inner.term || i"
                class="grid-slider__item-wrap"
              >
                <slot
                  v-if="inner"
                  :data="inner"
                  :index="index"
                  :i="i"
                />
              </div>
            </template>

            <template v-else-if="item">
              <slot :data="item" :index="index" :i="index" />
            </template>
          </div>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import HeadlineAction from '@/components/shared/HeadlineAction'
import { Swiper, Navigation, Pagination } from 'swiper'

Swiper.use([Navigation, Pagination])

const defaultOptions = {
  slidesPerView: 'auto',
  watchOverflow: true,
  resizeObserver: true,
  preventClicks: true,
  preventClicksPropagation: false,
  threshold: 12,
  navigation: {
    nextEl: '.next',
    prevEl: '.prev',
  },
  pagination: {
    el: '.swiper-pagination',
    type: 'bullets',
    dynamicBullets: true,
    dynamicMainBullets: 1,
  },
}

export default {
  name: 'GridSlider',
  components: {
    HeadlineAction,
  },
  props: {
    row: { type: Number, default: 1 },
    skipIndexes: { type: Array },
    list: { type: Array, required: true },
    options: { type: Object },
    hideNavigation: { type: Boolean, default: false },
    img: { type: String },
    title: { type: String },
    headerText: { type: String },
    textBtn: { type: String },
    linkBtn: { type: String },
    keyItem: { type: String, default: 'id' },
    hasFirstSlideCard: { type: Boolean },
  },
  data() {
    return {
      isLocked: false,
    }
  },
  computed: {
    hasFirstSlideSlot() {
      return this.hasFirstSlideCard
    },
    c_list() {
      const list = [...this.list]
      if (this.hasFirstSlideSlot) list.shift()
      const isArray = Array.isArray(list)
      if (!isArray) return []
      if (this.row === 1) return list

      if (this.skipIndexes && list.length > 0) {
        for (const position of this.skipIndexes) {
          list.splice(position, 0, null)
        }
      }

      const resultArrays = []

      for (let i = 0; i < list.length; i += this.row) {
        const chunk = list.slice(i, i + this.row)
        resultArrays.push(chunk)
      }

      return resultArrays
    },
    c_options() {
      return {
        ...defaultOptions,
        ...this.options,
        ...(this.$device.isMobile ? { freeMode: true } : null),
      }
    },
    isHideNavigation() {
      return this.isLocked || this.hideNavigation
    },
  },
  watch: {
    list(nexVal, prevVal) {
      if (nexVal === prevVal) return
      this.$nextTick(() => {
        this.update()
      })
    },
  },
  mounted() {
    const instanceSlider = this.swiper

    instanceSlider?.on('update', (e) => {
      this.$nextTick(() => {
        this.isLocked = this.swiper.isLocked
        this.$emit('update', instanceSlider)
      })
    })

    instanceSlider?.on('resize', (e) => {
      this.update()
      this.$emit('resize', instanceSlider)
    })

    this.$nextTick(() => {
      this.isLocked = this.swiper.isLocked
      this.update()
    })
  },
  methods: {
    publicInstance() {
      return this.swiper
    },
    update() {
      setTimeout(() => {
        this.swiper.update()
      }, 1000)
    },
  },
}
</script>

<style lang="scss" src="./style.scss" scoped></style>
